// hooks/useRealTimeClock.js

import { useEffect, useState } from "react";
import axios from "axios";

const API_URL =
    "https://timeapi.io/api/Time/current/zone?timeZone=Asia/Kolkata";

const useRealTimeClock = () => {
    const [time, setTime] = useState(null);
    const [timeData, setTimeData] = useState(null);
    const [todayDateTime, setTodayDateTime] = useState(null);
    const [todayDate, setTodayDate] = useState(null);
    const [todayTimeLoading, setTodayTimeLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let interval;

        const fetchTime = async () => {
            try {
                const res = await axios.get(API_URL);

                if (res?.status) {
                    setTimeData(res?.data)
                }

                const baseServerTime = new Date(res?.data?.dateTime).getTime();

                setTodayDateTime(baseServerTime)

                const baseClientTime = Date.now();
                setTodayDate(baseClientTime)

                interval = setInterval(() => {
                    const currentTime = new Date(
                        baseServerTime + (Date.now() - baseClientTime)
                    );
                    setTime(currentTime);
                }, 1000);

                setTodayTimeLoading(false);
            } catch (err) {
                setError(err);
                setTodayTimeLoading(false);
            }
        };

        fetchTime();

        return () => clearInterval(interval);
    }, []);

    return { time, timeData, todayDate, todayDateTime, todayTimeLoading, error };
};

export default useRealTimeClock;